import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import {
    ComparisonType,
    GameObject,
    MetricDirection,
    RankingByLogin,
    TooltipType,
} from "../game.models";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { GamesService } from "src/app/gamification/command-center/services/games.service";
import { TooltipDirective } from "ngx-bootstrap/tooltip";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "cxone-games-milestone",
    templateUrl: "./cxone-games-milestone.component.html",
    styleUrl: "./cxone-games-milestone.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CxoneGamesMilestoneComponent implements OnInit {
    @Input() game: GameObject;
    @Input() gameStatus: string;
    @Input() ranking: RankingByLogin;

    @ViewChild('qualifierText') qualifierText: ElementRef<HTMLElement>;
    @ViewChild('metricText', { static: false }) metricText: ElementRef;
    @ViewChild('tooltip', { static: false }) tooltip!: TooltipDirective;
    @ViewChild('tooltipQualifier', { static: false }) tooltipQualifier!: TooltipDirective;  
    @ViewChildren('tooltipMilestone') tooltipMilestone!: QueryList<NgbPopover>; 

    gs: GamesService = null;
    ComparisonType = ComparisonType;
    tooltipValidation = false;
    TooltipType = TooltipType;
    milestoneRewards: any[];

    constructor(
        public cvLocalizationService: CVLocalizationService,
        private gamesService: GamesService
    ) {
        this.gs = this.gamesService;
    }

    ngOnInit() {
        this.precalculateMilestoneRewards();
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "Games",
            key,
            defaultValue
        );
        return baseString;
    }

    isWinnerMilestone(index: number): string | number {
        if (!this.ranking?.gameRewards?.MyRankingObj) return "";

        if (this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos?.length === 0) return 0;

        let isQualified: boolean | null = null;
        if (this.game?.Qualifier != null) {
            isQualified = this.gs.isQualified(
                this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[1]?.MyMetricValue,
                this.game,
                this.ranking
            );
        }

        const metricValue =
            this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[0]
                ?.MyMetricValue;
        const { Val1: minValue, Val2: maxValue } =
            this.game!.MilestoneRewards[index].Target;
        let isWinner = false;

        if (this.game!.SelectedMetrics[0].direction === MetricDirection.Up) {
            if (
                this.game!.MilestoneRewards[index].ComparisonType ===
                ComparisonType.GreaterThan
            ) {
                isWinner = metricValue >= minValue;
            } else {
                isWinner =
                    metricValue >= maxValue ||
                    (metricValue >= minValue && metricValue <= maxValue);
            }
        } else {
            if (
                this.game!.MilestoneRewards[index].ComparisonType ===
                ComparisonType.LessThan
            ) {
                isWinner = metricValue <= minValue;
            } else {
                isWinner =
                    metricValue <= maxValue ||
                    (metricValue <= maxValue && metricValue >= minValue);
            }
        }

        if (this.game?.Qualifier != null && isQualified && isWinner) {
            return "done";
        } else if (
            this.game?.Qualifier == null &&
            isQualified == null &&
            isWinner
        ) {
            return "done";
        }
        return 0;
    }

    getTooltipMetric(index: number, count: number, isLast: boolean): string {
        if (isLast) {
            const isUpMetric =
                this.game!.SelectedMetrics[0].direction === MetricDirection.Up;
            const label = isUpMetric
                ? this.getLocalizationString("Greater_Than", "Greater Than")
                : this.getLocalizationString("Less_Than", "Less than");
            return `${label} ${
                this.game?.MilestoneRewards[count - 1 - index]?.Target?.Val1
            }`;
        }
        return `${
            this.game?.MilestoneRewards[count - 1 - index]?.Target?.Val1
        } ${this.getLocalizationString("To", "to")} ${
            this.game?.MilestoneRewards[count - 1 - index]?.Target?.Val2
        } ${this.game?.SelectedMetrics[0]?.abbrev}`;
    }

    checkTextTruncation(tooltip: string, type: TooltipType): string {
        this.tooltipValidation = true;
        switch (type) {
            case TooltipType.Q1:
                if (this.metricText) {
                    return this.metricText.nativeElement.scrollWidth != this.metricText.nativeElement.clientWidth ? tooltip : "";
                }
                break;
            case TooltipType.Q2:
                if (this.qualifierText) {
                    return this.qualifierText.nativeElement.scrollWidth != this.qualifierText.nativeElement.clientWidth ? tooltip : "";
                }
                break;        
            default: this.tooltipValidation = false;
        }
        return "";
    }

    precalculateMilestoneRewards() {
        this.milestoneRewards = this.game.MilestoneRewards.slice().reverse().map((reward, index) => {
            return {
                ...reward,
                coins: reward.Coins.rewardValue,
                badgeSrc: reward.Badge?.rewardValue ? `../Admin/ImageResizer.aspx?imgid=${reward.Badge.rewardValue}&w=24&h=24` : null
            };
        });
    }

    hideTooltip() {
        if (this.tooltip) {
            this.tooltip.hide();
        }

        if (this.tooltipQualifier) {
            this.tooltipQualifier.hide();
        }

        if (this.tooltipMilestone) {
            this.tooltipMilestone.forEach((tooltip) => tooltip.close());
        }
    }
}
